import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { normalizeSourceOfFundOptions } from "../helpers/riskControlSettingsUtils";

const DEFAULT_SETTINGS = {
  sourceOfFundOptions: normalizeSourceOfFundOptions(),
};

const RiskControlSettingsContext = createContext(DEFAULT_SETTINGS);

export const RiskControlSettingsProvider = ({ children }) => {
  const [api] = useServerApi();
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    let active = true;

    const loadSettings = async () => {
      try {
        const result = await api.search({
          apiEntity: "setting",
          pageSize: 1,
        });
        if (!active) return;
        setSettings({
          sourceOfFundOptions: normalizeSourceOfFundOptions(
            result?.docs?.[0]?.riskControl?.sourceOfFundOptions
          ),
        });
      } catch (error) {
        console.log(error);
      }
    };

    loadSettings();
    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(
    () => settings,
    [settings.sourceOfFundOptions]
  );

  return (
    <RiskControlSettingsContext.Provider value={value}>
      {children}
    </RiskControlSettingsContext.Provider>
  );
};

export const useRiskControlSettings = () => useContext(RiskControlSettingsContext);
